// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adv-listing-filters-clear[data-v-762d3e0b]{position:relative;display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:100%;border-right:1px solid #707070}.adv-listing-filters-clear-btn[data-v-762d3e0b]{display:block;width:100%;text-align:center;font-size:13px;line-height:1.2;color:#000}", ""]);
// Exports
module.exports = exports;
